<template>
<div v-if="inlineDisclaimerAndConsent === true"  class="row general-inactive-section">
  <div class="row">
          <div class="col-md-10 col-md-offset-1 cursor-pointer">
            <small>
              {{computeCaption(fields_en['by_continuing'], $store.state.lang.value.toLowerCase())}}
              <a class="text-danger" @click="drawerDisclaimer = true"
                > {{computeCaption(fields_en['terms_and_conditions'], $store.state.lang.value.toLowerCase())}}</a
              >
            </small>
            <el-drawer
              :title="allowDisclaimer && allowConsent ? 'Disclaimer & Consent' : allowConsent ? 'Consent' : allowDisclaimer ? 'Disclaimer' : ''"
              size="100%"
              :visible.sync="drawerDisclaimer"
            >
              <div class="row">
                <div class="col-md-10 col-md-offset-1 scrollableTerms">
                  <div class="form-group">
                    <h4 v-if="showAddressAndSite">
                      {{ siteName }}<br />
                      <small class="disclaimer-color">
                        {{ siteAddress }}</small
                      >
                      <hr />
                    </h4>
                  </div>
                  <h4 class="text-center" v-if='allowDisclaimer'>
                    <span v-if="labName">{{ labName + " " }}</span>
                    {{computeCaption(fields_en['disclaimer'], $store.state.lang.value.toLowerCase())}}
                  </h4>
                  <p class="disclaimer-color" v-if='allowDisclaimer' v-html="disclaimer"></p>
                   <h4 class="text-center" v-if='allowConsent'>
                    <span v-if="labName">{{ labName + " " }}</span>
                     {{computeCaption(fields_en['consent'], $store.state.lang.value.toLowerCase())}}
                  </h4>
                  <p class="disclaimer-color" v-if='allowConsent' v-html="consent"></p>
                  <hr />
                </div>
              </div>
            </el-drawer>
          </div>
    </div>
</div>
    <div v-else>
        <div v-if="allowDisclaimer">
                <div class="row" :name="partOfSection ? 'insurance-disclaimer' : ''">
                  <div class="col-md-10 col-md-offset-1">
                    <div class="form-group">
                      <h4 v-if="showAddressAndSite">
                        {{ siteName }}<br />
                        <small class="disclaimer-color">
                          {{ siteAddress }}</small
                        >
                        <hr />
                      </h4>
                    </div>
                    <h4 class="text-center">
                      <span v-if="labName">{{ labName + " " }}</span>
                      {{computeCaption(fields_en['disclaimer'], $store.state.lang.value.toLowerCase())}}
                    </h4>
                    <p :class="displayScrollbar ? 'disclaimer-color scroll-content' : 'disclaimer-color'" v-html="disclaimer"></p>
                    <hr />
                  </div>
                </div>
                 <div class="row">
                   <div :class="partOfSection ? 'col-md-12' : 'col-md-12 ' + validatedDisclaimerClass + ' ' + generalDisclaimerClass" v-touch:end="checkValidationsDisclaimer" v-on:mouseleave="checkValidationsDisclaimer" id="signatureDisclaimer">
                      <div class="col-md-10 col-md-offset-1 p-2" v-if="allowSignatureDisclaimer && allowSeparateSignature || allowSignatureDisclaimer && !allowConsent && !allowSeparateSignature">
                          <label class="control-label required" for="signature-disclaimer-kit">
                            {{computeCaption(fields_en['please_sign_here'], $store.state.lang.value.toLowerCase())}}
                          </label>
                          <VueSignaturePad class="signature" id="signature-disclaimer-kit" name="signature-disclaimer-kit" width="100%" height="200px" ref="signaturePadDisclaimer" :options="{onBegin: () => {$refs.signaturePadDisclaimer.resizeCanvas()}}" />
                          <div class="flex-end">
                            <br>
                            <el-button plain @click="clearDisclaimerSignature">{{computeCaption(fields_en['clear'], $store.state.lang.value.toLowerCase())}}</el-button>
                          </div>
                          <br>
                          <small class="text-danger" v-if="allowTextNameDisclaimer && signatureDisclaimerText === '' && submit ||  !this.validationObjectDisclaimer.signatureDisclaimerValidation && submit">
                            {{computeCaption(fields_en['please_sign'], $store.state.lang.value.toLowerCase())}}
                          </small>
                          <div class="row mt-5">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label class="control-label" :class="allowTextNameDisclaimer ? 'required' : ''" for="text-signature-patient-disclaimer">
                                  {{computeCaption(fields_en['if_you_can_not_sign'], $store.state.lang.value.toLowerCase())}}
                                </label>
                              </div>
                            </div>
                            <div class="col-md-7">
                              <div class="form-group">
                                <el-input type="textarea" :name="partOfSection ? '' : 'text-signature-patient-disclaimer'" id="text-signature-patient-disclaimer" v-model="signatureDisclaimerText" onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"></el-input>
                              </div>
                            </div>
                          </div>

                        </div>
                     <div :class="'col-md-12 '" v-if="allowCheckboxDisclaimer">
                       <p-checkbox v-model="agreeDisclaimer" name="agreedDisclaimer" class="required col-md-12 col-md-offset-1"
                       > {{ computeCaption(fields_en['i_agree'], $store.state.lang.value.toLowerCase()) }} </p-checkbox>
                       <small class="col-md-offset-1 text-danger" v-show="submit && !agreeDisclaimer">
                         {{computeCaption(fields_en['agreeError'], $store.state.lang.value.toLowerCase())}}
                       </small>
                     </div>
                   </div>
          </div>
         </div>
      <!-- CONSENT -->
         <div v-if="allowConsent" name="consent">
               <div class="row">
                  <div class="col-md-10 col-md-offset-1">
                    <div class="form-group">
                      <h4 v-if="showAddressAndSite">
                        {{ siteName }}<br />
                        <small class="disclaimer-color">
                          {{ siteAddress }}</small
                        >
                        <hr />
                      </h4>
                    </div>
                    <h4 class="text-center">
                      <span v-if="labName">{{ labName + " " }}</span>
                      {{computeCaption(fields_en['disclaimer'], $store.state.lang.value.toLowerCase())}}
                    </h4>
                    <p :class="displayScrollbar ? 'disclaimer-color scroll-content' : 'disclaimer-color'" v-html="consent"></p>
                    <hr />
                  </div>
                 <div :class="partOfSection ? 'col-md-12' : 'col-md-12 ' + validatedConsentClass + ' ' + generalConsentClass"
                      v-on:mouseleave="checkValidationsConsent"
                      v-touch:end="checkValidationsConsent"
                      id="signatureConsent"
                     >
                   <div class="col-md-10 col-md-offset-1 p-2"  v-if="allowSignatureConsent && allowSeparateSignature || allowSignatureConsent && !allowDisclaimer && !allowSeparateSignature">
                    <label class="control-label required" for="signature-disclaimer-kit">
                      {{computeCaption(fields_en['please_sign_here'], $store.state.lang.value.toLowerCase())}}
                    </label>
                    <VueSignaturePad class="signature" id="signature-disclaimer-kit" name="signature-disclaimer-kit" width="100%" height="200px" ref="signaturePadConsent" :options="{onBegin: () => {$refs.signaturePadConsent.resizeCanvas()}}" />
                    <div class="flex-end">
                      <br>
                      <el-button plain @click="clearConsentSignature">{{computeCaption(fields_en['clear'], $store.state.lang.value.toLowerCase())}}</el-button>
                    </div>
                    <br>
                    <small class="text-danger" v-if="allowTextNameConsent && signatureConsentText === '' && submit || !this.validationObjectConsent.signatureConsentValidation && submit">
                      {{computeCaption(fields_en['please_sign'], $store.state.lang.value.toLowerCase())}}
                    </small>
                    <div class="row mt-5">
                      <div class="col-md-5">
                        <div class="form-group">
                          <label class="control-label" :class="allowTextNameConsent ? 'required' : ''" for="text-signature-patient-consent">
                            {{computeCaption(fields_en['if_you_can_not_sign_consent'], $store.state.lang.value.toLowerCase())}}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-7">
                        <div class="form-group">
                          <el-input type="textarea" :name="partOfSection ? '' : 'text-signature-patient-consent'" id="text-signature-patient-consent" v-model="signatureConsentText" onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                   <div :class="'col-md-12 '" v-if="allowCheckboxConsent">
                     <p-checkbox v-model="agreeConsent" name="agreedConsent" class="required col-md-12 col-md-offset-1"
                     > {{ computeCaption(fields_en['i_agree'], $store.state.lang.value.toLowerCase()) }} </p-checkbox>
                     <small class="text-danger col-md-offset-1" v-show="submit && !agreeConsent">
                       {{computeCaption(fields_en['agreeError'], $store.state.lang.value.toLowerCase())}}
                     </small>
                   </div>
                 </div>
              </div>
        </div>
        <!-- Same signature if they are both allowed (consent & disclaimer) -->
      <div class="col-md-12" :class="[generalConsentClass, validatedConsentClass]" id="signatureConsentDisclaimer" v-touch:end="checkValidationsConsent" v-on:mouseleave="checkValidationsConsent" v-if="allowConsent && allowDisclaimer && !allowSeparateSignature">
        <div class="col-md-10 col-md-offset-1 p-2 mb-2" >
           <div v-if="allowSignatureConsent && !allowSeparateSignature" id="signatureBox">
              <label class="control-label required" for="signature-disclaimer-kit">
                {{computeCaption(fields_en['please_sign_here'], $store.state.lang.value.toLowerCase())}}
              </label>
              <VueSignaturePad class="signature" id="signature-disclaimer-kit" name="signature-disclaimer-kit" width="100%" height="200px" ref="signaturePadSingle" :options="{onBegin: () => {$refs.signaturePadSingle.resizeCanvas()}}" />
              <div class="flex-end">
                <br>
                <el-button plain @click="()=>{clearSingleSignature()}">{{computeCaption(fields_en['clear'], $store.state.lang.value.toLowerCase())}}</el-button>
              </div>
              <br>
              <small class="text-danger" v-if="allowTextNameConsent && !signatureConsentText && submit ||  !signatureConsent && submit">
                {{computeCaption(fields_en['please_sign'], $store.state.lang.value.toLowerCase())}}
              </small>
              <small class="text-danger" v-if="!allowTextNameConsent && !signatureConsent && submit">
                {{computeCaption(fields_en['please_sign'], $store.state.lang.value.toLowerCase())}}
              </small>
              <div class="row mt-5">
                <div class="col-md-5">
                  <div class="form-group">
                    <label class="control-label" :class="allowTextNameConsent ? 'required' : ''" for="text-signature-patient-single">
                      {{computeCaption(fields_en['if_you_can_not_sign_consent'], $store.state.lang.value.toLowerCase())}}
                    </label>
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="form-group">
                    <el-input type="textarea" :name="partOfSection ? '' : 'text-signature-patient-single'" id="text-signature-patient-single" v-model="signatureSingleText" onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"></el-input>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <canvas class="disclaimer-consent-canvas" id="disclaimer-consent-canvas"></canvas>
  </div>
</template>

<script>
import {Button, Input, Drawer} from 'element-ui'
import {TranslationsUtils} from '../../../../utils/Translations'
export default {
  name: 'ConsentDisclaimer',
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    [Drawer.name]: Drawer
  },
  mixins: [TranslationsUtils],
  props: {
    submit: {default: undefined},
    inline_disclaimer_and_consent: {default: undefined},
    allow_separate_signature: {default: undefined},
    allow_consent: {default: undefined},
    allow_disclaimer: {default: undefined},
    allow_text_name_disclaimer: {default: undefined},
    disclaimer_name_text: {default: undefined},
    allow_signature_disclaimer: {default: undefined},
    allow_text_name_consent: {default: undefined},
    consent_name_text: {default: undefined},
    allow_signature_consent: {default: undefined},
    allow_checkbox_disclaimer: {default: undefined},
    allow_checkbox_consent: {default: undefined},
    consent_en: {default: undefined},
    consent_zh: {default: undefined},
    consent_es: {default: undefined},
    disclaimer_en: {default: undefined},
    disclaimer_zh: {default: undefined},
    disclaimer_es: {default: undefined},
    partOfSection: {default: false}
  },
  data () {
    return {
      inlineDisclaimerAndConsent: '',
      allowSeparateSignature: '',
      allowConsent: '',
      allowDisclaimer: '',
      allowTextNameDisclaimer: '',
      disclaimerNameText: '',
      allowSignatureDisclaimer: '',
      allowTextNameConsent: '',
      consentNameText: '',
      allowSignatureConsent: '',
      agreeConsent: false,
      agreeDisclaimer: false,
      allowCheckboxDisclaimer: false,
      consentEn: '',
      consentZh: '',
      consentEs: '',
      disclaimerEn: '',
      disclaimerZh: '',
      disclaimerEs: '',
      siteName: this.$store.state.site.name,
      siteAddress: this.$store.state.site.address,
      displayScrollbar: false,
      validationObjectConsent: {
        signatureConsentValidation: false,
        signatureConsentTextValidation: false,
        agreedConsentValidation: false
      },
      validationObjectDisclaimer: {
        signatureDisclaimerValidation: false,
        signatureDisclaimerTextValidation: false,
        agreedDisclaimerValidation: false
      },
      generalConsentClass: 'general-inactive-section',
      generalDisclaimerClass: 'general-inactive-section',
      validatedConsentClass: '',
      validatedDisclaimerClass: '',
      labName: this.$store.state.configs.LAB_NAME,
      showAddressAndSite: this.$store.state.configs.SHOW_ADDRESS_DISCLAIMER,
      drawerDisclaimer: false,
      disclaimer: '',
      consent: '',
      signatureDisclaimer: '',
      signatureDisclaimerText: '',
      signatureConsent: '',
      signatureConsentText: '',
      signatureSingleText: '',
      fields_en: {
        by_continuing: 'By continuing you agree to our',
        terms_and_conditions: 'terms and conditions',
        if_you_can_not_sign: 'If you can not sign using the signature panel above, please type your full name as your signature here',
        if_you_can_not_sign_consent: 'If you can not sign using the signature panel above, please type your full name as your signature here',
        back: 'Back',
        register: 'Register',
        client_bill: 'Client Bill',
        select_payment_type: 'Select Payment Type',
        insurance: 'Insurance',
        uninsured: 'Uninsured',
        cash: 'Cash',
        please_provide_payment_information: 'Please Provide Payment Information',
        primary_insurance_name: 'Primary Insurance Name',
        policy_number: 'Policy Number',
        group_number: 'Group Number',
        insurance_card: 'Insurance Card',
        patient_relationship_to_insured: 'Patient Relationship to Insured',
        note: 'Note',
        patient: 'Select patient',
        submitting: 'Submitting... please wait',
        agreeError: 'Please check',
        i_agree: 'I agree',
        clear: 'Clear',
        please_sign_here: 'Patient or Legal Guardian Signature',
        please_sign: 'Please Sign!'
      }
    }
  },
  created () {
    this.inlineDisclaimerAndConsent = (this.inline_disclaimer_and_consent !== undefined) ? this.inline_disclaimer_and_consent : this.$store.state.configs.INLINE_DISCLAIMER_AND_CONSENT
    this.allowSeparateSignature = (this.allow_separate_signature !== undefined) ? !this.allow_separate_signature : !(this.$store.state.configs.DISCLAIMER_AND_CONSENT_SINGLE_SIGNATURE)
    this.allowConsent = (this.allow_consent !== undefined) ? this.allow_consent : this.$store.state.configs.ALLOW_CONSENT
    this.allowDisclaimer = (this.allow_disclaimer !== undefined) ? this.allow_disclaimer : this.$store.state.configs.ALLOW_DISCLAIMER
    this.allowTextNameDisclaimer = (this.allow_text_name_disclaimer !== undefined) ? this.allow_text_name_disclaimer : this.$store.state.configs.DISCLAIMER_NAME_TEXT_REQUIREMENT
    this.disclaimerNameText = (this.disclaimer_name_text !== undefined) ? this.disclaimer_name_text : this.$store.state.configs.DISCLAIMER_NAME_TEXT
    this.consentNameText = (this.consent_name_text !== undefined) ? this.consent_name_text : this.$store.state.configs.CONSENT_NAME_TEXT
    this.allowSignatureDisclaimer = (this.allow_signature_disclaimer !== undefined) ? this.allow_signature_disclaimer : this.$store.state.configs.ALLOW_SIGNATURE_DISCLAIMER
    this.allowTextNameConsent = (this.allow_text_name_consent !== undefined) ? this.allow_text_name_consent : this.$store.state.configs.CONSENT_NAME_TEXT_REQUIREMENT
    this.consentNameText = (this.consent_name_text !== undefined) ? this.consent_name_text : this.$store.state.configs.CONSENT_NAME_TEXT
    this.allowSignatureConsent = (this.allow_signature_consent !== undefined) ? this.allow_signature_consent : this.$store.state.configs.ALLOW_SIGNATURE_CONSENT
    this.allowCheckboxDisclaimer = (this.allow_checkbox_disclaimer !== undefined) ? this.allow_checkbox_disclaimer : this.$store.state.configs.ALLOW_CHECKBOX_DISCLAIMER
    this.allowCheckboxConsent = (this.allow_checkbox_consent !== undefined) ? this.allow_checkbox_consent : this.$store.state.configs.ALLOW_CHECKBOX_CONSENT
    this.consentEn = (this.consent_en !== undefined) ? this.consent_en : this.$store.state.site.patient_registration_consent
    this.consentZh = (this.consent_zh !== undefined) ? this.consent_zh : this.$store.state.site.patient_registration_consent_zh
    this.consentEs = (this.consent_es !== undefined) ? this.consent_es : this.$store.state.site.patient_registration_consent_es
    this.disclaimerEn = (this.disclaimer_en !== undefined) ? this.disclaimer_en : this.$store.state.site.patient_disclaimer
    this.disclaimerZh = (this.disclaimer_zh !== undefined) ? this.disclaimer_zh : this.$store.state.site.patient_disclaimer_zh
    this.disclaimerEs = (this.disclaimer_es !== undefined) ? this.disclaimer_es : this.$store.state.site.patient_disclaimer_es
    this.displayScrollbar = this.$store.state.configs.SCROLLBAR_DISCLAIMER_CONSENT
    this.siteName = this.$store.state.site.name
    this.siteAddress = this.$store.state.site.address
    this.fields_en.if_you_can_not_sign = (this.disclaimerNameText !== undefined) ? this.disclaimerNameText : 'If you can not sign using the signature panel above, please type your full name as your signature here'
    this.fields_en.if_you_can_not_sign_consent = (this.consentNameText !== undefined) ? this.consentNameText : 'If you can not sign using the signature panel above, please type your full name as your signature here'
    this.$store.state.consentSignature = ''
    if (!this.allowCheckboxConsent) {
      this.validationObjectConsent.agreedConsentValidation = true
    }
    if (!this.allowSignatureConsent) {
      this.validationObjectConsent.signatureConsentValidation = true
      this.validationObjectConsent.signatureConsentTextValidation = true
    }
    if (!this.allowCheckboxDisclaimer) {
      this.validationObjectDisclaimer.agreedDisclaimerValidation = true
    }
    if (!this.allowSignatureDisclaimer) {
      this.validationObjectDisclaimer.signatureDisclaimerValidation = true
      this.validationObjectDisclaimer.signatureDisclaimerTextValidation = true
    }
    if (!this.allowConsent) {
      Object.entries(this.validationObjectConsent).forEach(([key, value]) => {
        this.validationObjectConsent[key] = true
      })
    }
    if (!this.allowDisclaimer) {
      Object.entries(this.validationObjectDisclaimer).forEach(([key, value]) => {
        this.validationObjectDisclaimer[key] = true
      })
    }
  },
  methods: {
    checkValidationsConsent () {
      if (this.allowSeparateSignature && this.allowConsent) {
        if (!this.allowTextNameConsent) {
          this.validationObjectConsent.signatureConsentTextValidation = true
        }
        if (!this.$refs.signaturePadConsent.isEmpty() || this.signatureConsentText !== '' && !this.allowTextNameConsent) {
          this.validationObjectConsent.signatureConsentValidation = true
        } else {
          this.validationObjectConsent.signatureConsentValidation = false
        }
      }
      if (!this.allowSeparateSignature && this.allowConsent) {
        if (this.$refs.signaturePadSingle.isEmpty()) {
          this.validationObjectConsent.signatureConsentValidation = false
        } else {
          this.validationObjectConsent.signatureConsentValidation = true
        }
      }
    },
    checkValidationsDisclaimer () {
      if (!this.allowTextNameDisclaimer) {
        this.validationObjectDisclaimer.signatureDisclaimerTextValidation = true
      }
      if (this.$refs.signaturePadDisclaimer !== undefined) {
        if (!this.$refs.signaturePadDisclaimer.isEmpty() || this.signatureDisclaimerText !== '' && !this.allowTextNameDisclaimer) {
          this.validationObjectDisclaimer.signatureDisclaimerValidation = true
        } else {
          this.validationObjectDisclaimer.signatureDisclaimerValidation = false
        }
      }
      if (this.partOfSection) {
        if (this.allowSignatureDisclaimer) {
          if (this.$refs.signaturePadDisclaimer.isEmpty()) {
            if (!this.allowTextNameDisclaimer && this.signatureDisclaimerText === '') {
              this.$emit('validateSignature', false)
            }
          } else {
            this.saveSignatureDisclaimer()
            this.$emit('validateSignature', true)
          }
        }
      }
    },
    async disclaimer_text () {
      this.text = ''
      if (this.$store.state.lang.value === 'ES' && this.disclaimerEs) {
        this.text = this.disclaimerEs
      } else {
        if (this.$store.state.lang.value === 'ZH' && this.disclaimerZh) {
          this.text = this.disclaimerZh
        } else {
          if (this.$store.state.lang.value === 'EN' && this.disclaimerEn) {
            this.text = this.disclaimerEn
          }
        }
      }
      let linksArray = this.text.match(/<a href="(.*?)">/g)
      if (linksArray) {
        for (let i = 0; i < linksArray.length; i++) {
            // if doesn't have target already put it
          if (!linksArray[i].includes('target="_blank')) {
            // controll if link has protocol if yes just add target
            if (linksArray[i].includes('http') || linksArray[i].includes('https') || linksArray[i].includes('href="//')) {
              let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('>')) + ' target="_blank"' + linksArray[i].slice(linksArray[i].indexOf('>'))
              this.text = this.text.replace(linksArray[i], toReturn)
            // if it doesn't have protocol add // so it wont redirect to localhost/www.userlink.com
            } else {
              let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('href="') + 6) + '//' + linksArray[i].slice(9)
              this.text = this.text.replace(linksArray[i], toReturn)
            }
          }
        }
      }
      return this.text
    },
    async consent_text () {
      this.text1 = ''
      if (this.$store.state.lang.value === 'ES' && this.consentEs) {
        this.text1 = this.consentEs
      } else {
        if (this.$store.state.lang.value === 'ZH' && this.consentZh) {
          this.text1 = this.consentZh
        } else {
          if (this.$store.state.lang.value === 'EN' && this.consentEn) {
            this.text1 = this.consentEn
          }
        }
      }
      let linksArray = this.text1.match(/<a href="(.*?)">/g)
      if (linksArray) {
        for (let i = 0; i < linksArray.length; i++) {
            // if doesn't have target already put it
          if (!linksArray[i].includes('target="_blank')) {
            // controll if link has protocol if yes just add target
            if (linksArray[i].includes('http') || linksArray[i].includes('https') || linksArray[i].includes('href="//')) {
              let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('>')) + ' target="_blank"' + linksArray[i].slice(linksArray[i].indexOf('>'))
              this.text1 = this.text1.replace(linksArray[i], toReturn)
              // if it doesn't have protocol add // so it wont redirect to localhost/www.userlink.com
            } else {
              let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('href="') + 6) + '//' + linksArray[i].slice(9)
              this.text1 = this.text1.replace(linksArray[i], toReturn)
            }
          }
        }
      }
      return this.text1
    },
    clearDisclaimerSignature () {
      this.signatureDisclaimerText = ''
      if (this.$refs.signaturePadDisclaimer !== undefined) {
        this.$refs.signaturePadDisclaimer.clearSignature()
      }
      this.checkValidationsDisclaimer()
    },
    clearConsentSignature () {
      this.$refs.signaturePadConsent.clearSignature()
      this.checkValidationsConsent()
    },
    clearSingleSignature () {
      this.$refs.signaturePadSingle.clearSignature()
      this.checkValidationsConsent()
    },
    saveSignatureDisclaimer () {
      const { data } = this.$refs.signaturePadDisclaimer.saveSignature()
      this.signatureDisclaimer = data
      if (this.signatureDisclaimer !== '') {
        this.$store.state.consentSignature = this.signatureDisclaimer
      }
    },
    saveSignatureConsent () {
      const { data } = this.$refs.signaturePadConsent.saveSignature()
      this.signatureConsent = data
      if (this.signatureConsent !== '') {
        this.$store.state.consentSignature = this.signatureConsent
      }
    },
    saveSignatureSingle () {
      const { data } = this.$refs.signaturePadSingle.saveSignature()
      this.signatureDisclaimer = data
      this.signatureConsent = data
    },
    checkValidatedObject (object) {
      return Object.values(object).every(field => field === true)
    },
    async validate () {
      if (!this.allowConsent && !this.allowDisclaimer) {
        return true
      }
      if (this.inlineDisclaimerAndConsent === true) {
        return true
      }
      if (this.allowSignatureDisclaimer && this.allowSeparateSignature && this.allowDisclaimer) {
        this.saveSignatureDisclaimer()
      }
      if (this.allowSignatureConsent && this.allowSeparateSignature && this.allowConsent) {
        this.saveSignatureConsent()
      }
      if (this.allowSignatureConsent && this.allowSignatureDisclaimer && this.allowDisclaimer && this.allowConsent && !this.allowSeparateSignature) {
        this.saveSignatureSingle()
        if (this.signatureSingleText) {
          this.signatureDisclaimerText = this.signatureSingleText
          this.signatureConsentText = this.signatureSingleText
        } else {
          this.signatureDisclaimerText = ''
          this.signatureConsentText = ''
        }
      }
      await this.assignTextSignatures()
      if (this.checkValidatedObject(this.validationObjectConsent) && this.checkValidatedObject(this.validationObjectDisclaimer)) {
        return true
      }
      this.focusValidateInputs()
      return false
    },
    assignTextSignatures () {
      if (this.allowSignatureDisclaimer && !this.signatureDisclaimer && this.allowDisclaimer) {
        if (!this.allowTextNameDisclaimer && this.signatureDisclaimerText) {
          let canvasValue = document.getElementById('disclaimer-consent-canvas').getContext('2d') // Hidden canvas
          this.signatureDisclaimer = canvasValue.canvas.toDataURL()
          if (this.$store.state.consentSignature === '' || this.$store.state.consentSignature === undefined) {
            this.$store.state.consentSignature = this.signatureDisclaimer
          }
        }
      }
      if (this.allowSignatureConsent && !this.signatureConsent && this.allowConsent) {
        if (!this.allowTextNameConsent && this.signatureConsentText) {
          let canvasValue = document.getElementById('disclaimer-consent-canvas').getContext('2d') // Hidden canvas
          this.signatureConsent = canvasValue.canvas.toDataURL()
          if (this.$store.state.consentSignature === '' || this.$store.state.consentSignature === undefined) {
            this.$store.state.consentSignature = this.signatureConsent
          }
        }
      }
    },
    focusValidateInputs () {
      if (!this.$validator.errors.items.length) {
        if (this.partOfSection && this.signatureDisclaimer === undefined) {
          let disclaimerInsurance = document.getElementsByName('insurance-disclaimer')
          disclaimerInsurance[0].scrollIntoView({behavior: 'smooth', block: 'start'})
          return false
        } else if (this.partOfSection === undefined || this.partOfSection === false) {
          let singleTextSignature = document.getElementsByName('text-signature-patient-single')
          let disclaimerTextSignature = document.getElementsByName('text-signature-patient-disclaimer')
          let consentTextSignature = document.getElementsByName('text-signature-patient-consent')
          let disclaimerCheckbox = document.getElementsByName('agreedDisclaimer')
          let consentCheckbox = document.getElementsByName('agreedConsent')
          if (this.allowSeparateSignature) {
            if (this.allowDisclaimer && this.allowSignatureDisclaimer && this.signatureDisclaimerText === '') {
              this.validatedDisclaimerClass = 'invalid-section-class'
              this.generalDisclaimerClass = 'general-invalid-section'
              disclaimerTextSignature[0].focus()
              return false
            }
            if (this.allowDisclaimer && this.allowCheckboxDisclaimer && !this.agreeDisclaimer) {
              this.validatedDisclaimerClass = 'invalid-section-class'
              this.generalDisclaimerClass = 'general-invalid-section'
              let panel = document.getElementsByClassName('main-panel')[0]
              let topEl = disclaimerCheckbox[0].getBoundingClientRect().top
              panel.scrollTop = panel.scrollTop + topEl - 130
              return false
            }
            if (this.allowConsent && this.allowSignatureConsent && this.signatureConsentText === '') {
              this.validatedConsentClass = 'invalid-section-class'
              this.generalConsentClass = 'general-invalid-section'
              consentTextSignature[0].focus()
              return false
            }
            if (this.allowConsent && this.allowCheckboxConsent && !this.agreeConsent) {
              this.validatedDisclaimerClass = 'invalid-section-class'
              this.generalDisclaimerClass = 'general-invalid-section'
              let panel = document.getElementsByClassName('main-panel')[0]
              let topEl = consentCheckbox[0].getBoundingClientRect().top
              panel.scrollTop = panel.scrollTop + topEl - 130
              return false
            }
          } else {
            if (this.allowTextNameConsent && this.signatureConsentText === '') {
              singleTextSignature[0].focus()
            }
          }
        }
      }
    }
  },
  async beforeMount () {
    this.disclaimer = await this.disclaimer_text()
    this.consent = await this.consent_text()
    this.generalConsentClass = 'general-inactive-section'
    this.generalDisclaimerClass = 'general-inactive-section'
    this.validatedConsentClass = ''
    this.validatedDisclaimerClass = ''
  },
  watch: {
    '$store.state.site.address': {
      handler: function (value) {
        this.siteAddress = this.$store.state.site.address
      }
    },
    '$store.state.site.name': {
      handler: function (value) {
        this.siteName = this.$store.state.site.name
      }
    },
    '$store.state.lang': {
      handler: async function (value) {
        this.disclaimer = await this.disclaimer_text()
        this.consent = await this.consent_text()
      }
    },
    'allow_disclaimer': {
      handler: function (value) {
        this.allowDisclaimer = (this.allow_disclaimer !== undefined) ? this.allow_disclaimer : this.$store.state.configs.ALLOW_DISCLAIMER
        if (this.partOfSection && this.allowDisclaimer) {
          this.allowCheckboxDisclaimer = false
        }
        if (this.partOfSection && !this.allowDisclaimer) {
          this.allowCheckboxDisclaimer = true
        }
      }
    },
    'allow_signature_disclaimer': {
      handler: function (value) {
        this.allowSignatureDisclaimer = (this.allow_signature_disclaimer !== undefined) ? this.allow_signature_disclaimer : this.$store.state.configs.ALLOW_SIGNATURE_DISCLAIMER
      }
    },
    'agreeConsent': {
      handler: function (value) {
        if (this.agreeConsent) {
          this.validationObjectConsent.agreedConsentValidation = true
        } else {
          this.validationObjectConsent.agreedConsentValidation = false
        }
      }
    },
    'agreeDisclaimer': {
      handler: function (value) {
        if (this.agreeDisclaimer) {
          this.validationObjectDisclaimer.agreedDisclaimerValidation = true
          if (this.partOfSection) {
            this.$emit('validateSignature', true)
          }
        } else {
          this.validationObjectDisclaimer.agreedDisclaimerValidation = false
          if (this.partOfSection) {
            this.$emit('validateSignature', false)
          }
        }
      }
    },
    'disclaimer': {
      handler: async function (value) {
        if (this.partOfSection && !this.allowSignatureDisclaimer) {
          this.$emit('validateSignature', true)
        }
      }
    },
    'disclaimer_en': {
      handler: async function (value) {
        this.disclaimerEn = (this.disclaimer_en !== undefined) ? this.disclaimer_en : this.$store.state.site.patient_disclaimer
        this.disclaimer = await this.disclaimer_text()
      }
    },
    'disclaimer_es': {
      handler: async function (value) {
        this.disclaimerEs = (this.disclaimer_es !== undefined) ? this.disclaimer_es : this.$store.state.site.patient_disclaimer_es
        this.disclaimer = await this.disclaimer_text()
      }
    },
    'disclaimer_zh': {
      handler: async function (value) {
        this.disclaimerZh = (this.disclaimer_zh !== undefined) ? this.disclaimer_zh : this.$store.state.site.patient_disclaimer_zh
        this.disclaimer = await this.disclaimer_text()
      }
    },
    'consent_en': {
      handler: async function (value) {
        this.consentEn = (this.consent_en !== undefined) ? this.consent_en : this.$store.state.site.patient_consent
        this.consent = await this.consent_text()
      }
    },
    'signatureConsentText': {
      handler: function (value) {
        if (this.allowTextNameConsent) {
          if (this.signatureConsentText) {
            this.validationObjectConsent.signatureConsentTextValidation = true
          } else {
            this.validationObjectConsent.signatureConsentTextValidation = false
          }
        } else {
          this.validationObjectConsent.signatureConsentTextValidation = true
          if (this.signatureConsentText) {
            this.validationObjectConsent.signatureConsentValidation = true
          } else {
            this.validationObjectConsent.signatureConsentValidation = false
          }
        }
        if (this.allowSignatureConsent && !this.signatureConsent && this.allowConsent) {
          if (!this.allowTextNameConsent && this.signatureConsentText) {
            let canvasValue = document.getElementById('disclaimer-consent-canvas').getContext('2d') // Hidden canvas
            canvasValue.canvas.width = 450
            canvasValue.font = '72px "Allison"'
            canvasValue.fillText(this.signatureConsentText, 30, 90)
          }
        }
      }
    },
    'signatureDisclaimerText': {
      handler: function (value) {
        if (this.allowTextNameDisclaimer) {
          if (this.signatureDisclaimerText) {
            this.validationObjectDisclaimer.signatureDisclaimerTextValidation = true
          } else {
            this.validationObjectDisclaimer.signatureDisclaimerTextValidation = false
          }
        } else {
          this.validationObjectDisclaimer.signatureDisclaimerTextValidation = true
          if (this.signatureDisclaimerText) {
            this.$emit('validateSignature', true)
            this.validationObjectDisclaimer.signatureDisclaimerValidation = true
          } else {
            this.validationObjectDisclaimer.signatureDisclaimerValidation = false
          }
        }
        if (this.allowSignatureDisclaimer && !this.signatureDisclaimer && this.allowDisclaimer) {
          if (!this.allowTextNameDisclaimer && this.signatureDisclaimerText) {
            let canvasValue = document.getElementById('disclaimer-consent-canvas').getContext('2d') // Hidden canvas
            canvasValue.canvas.width = 450
            canvasValue.font = '72px "Allison"'
            canvasValue.fillText(this.signatureDisclaimerText, 30, 90)
          }
        }
      }
    },
    'signatureSingleText': {
      handler: function (value) {
        if (this.allowTextNameConsent && !this.allowSeparateSignature) {
          if (this.signatureSingleText) {
            this.validationObjectConsent.signatureConsentTextValidation = true
          } else {
            this.validationObjectConsent.signatureConsentTextValidation = false
          }
        } else {
          this.validationObjectConsent.signatureConsentTextValidation = true
          if (this.signatureSingleText) {
            this.validationObjectConsent.signatureConsentValidation = true
          } else {
            this.validationObjectConsent.signatureConsentValidation = false
          }
        }
      }
    },
    'validationObjectConsent': {
      handler: function (before, after) {
        if (this.checkValidatedObject(this.validationObjectConsent)) {
          this.validatedConsentClass = 'validated-section-class'
          this.generalConsentClass = 'general-inactive-section'
        } else {
          this.validatedConsentClass = 'invalid-section-class'
          this.generalConsentClass = 'general-invalid-section'
        }
      },
      deep: true
    },
    'validationObjectDisclaimer': {
      handler: function (before, after) {
        if (this.checkValidatedObject(this.validationObjectDisclaimer)) {
          this.validatedDisclaimerClass = 'validated-section-class'
          this.generalDisclaimerClass = 'general-inactive-section'
        } else {
          this.validatedDisclaimerClass = 'invalid-section-class'
          this.generalDisclaimerClass = 'general-invalid-section'
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/paper/_variables.scss';
.scrollableTerms{
overflow: auto;
height: 90vh;
max-height: 30%;
}
.general-inactive-section {
  transition: 0.4s;
}
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}
.p-2{
  padding:20px;
}
.mb-2 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/ConsentDisclaimer.vue